import React, { useEffect } from "react";
import AppBody from "../../components/AppBody";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTrainingTrainerRequirementStatus } from "../../../actions/trainer/assign_trainer_action";

const ShowTrainerRequirementConfim = () => {
  const dispatch = useDispatch("");
  const state = useSelector((state) => state.assignTrainerReducer);
  const navigate = useNavigate();
  const { trainer_id, take_call_id } = useParams();
  useEffect(() => {
    dispatch(
      getTrainingTrainerRequirementStatus({
        trainer_id: atob(trainer_id),
        take_call_id: atob(take_call_id)
      })
    );
  }, []);

  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0 shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/completed-trainings"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Confirm Trainer Requirements
              </h4>
            </div>
            <div className="card-body p-4 w-100 border-0 ">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Selected Requirement</th>
                      <th>Requirement</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.requirements &&
                      state.requirements.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>
                            <input
                              type="checkbox"
                              className="form-control assign-check"
                              value={li.trId}
                              readOnly={true}
                              checked={li.status === 1 ? true : false}
                            />
                          </td>
                          <td>{li.requirement}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ShowTrainerRequirementConfim;
